export default __webpack_public_path__ + "static/ProValue_6@mob-1165735a0e00dca1ecce4b688f195493.webp";